export const FEEDBACK_JOURNEY = "GLOBAL_SEARCH";

export const FEEDBACK_REQUEST_TYPE = "SKELETON";

export const FEEDBACK_TITLE = "Feedback";

export const TYPE_AHEAD_LIMIT = 10;

export const TITLE_MAX_LENGTH = 64;

export const SEARCH_TYPES = {
    RECENT: "RECENT",
    SUGGESTED: "SUGGESTED",
    TYPE_AHEAD: "TYPE_AHEAD",
};
